import React, { useState, useRef, useEffect } from "react";
import useAuth from "../../../Hooks/useAuth";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import Masonry from "masonry-layout";
import LoginSecurityWidget from "../../../components/BusinessDashboard/LoginSecurityWidget";
// import PublicAccountStatusWidget from "../../../components/BusinessDashboard/PublicAccountStatusWidget";
import AccountClosureWidget from "../../../components/BusinessDashboard/AccountClosureWidget";

const SecurityVerification = () => {
  useAuth();

  // Masonry setup
  const masonryGridRef = useRef(null);
  useEffect(() => {
    if (masonryGridRef.current) {
      try {
        const images = masonryGridRef.current.querySelectorAll('img');
        const imagePromises = Array.from(images).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        });
        Promise.all(imagePromises).then(() => {
          if (masonryGridRef.current && typeof Masonry !== 'undefined') {
            const masonry = new Masonry(masonryGridRef.current, {
              itemSelector: '.masonry-item',
              columnWidth: 10,
              gutter: 0,
            });
            const handleResize = () => masonry && masonry.layout && masonry.layout();
            window.addEventListener('resize', handleResize);
            if (masonryGridRef.current) {
              masonryGridRef.current.masonry = masonry;
            }
            return () => {
              window.removeEventListener('resize', handleResize);
              if (masonryGridRef.current?.masonry) {
                masonryGridRef.current.masonry.destroy();
              }
            };
          }
        });
      } catch (e) {
        console.log('Masonry failed to init on security verification page:', e);
      }
    }
  }, []);

  return (
    <DashboardMainContainer className="!bg-white">
      <div className="w-full">
        <div ref={masonryGridRef} className="masonry-grid">
          <LoginSecurityWidget />
          <AccountClosureWidget />
        </div>
      </div>
    </DashboardMainContainer>
  );
};

export default SecurityVerification;
